<div class="min-h-screen flex flex-col bg-gray-50 font-sans">
  
  <!-- Top Navigation Bar -->
  <header class="bg-[#1D4586] text-white px-6 py-4 flex justify-between items-center shadow-sm z-20 shrink-0">
    <div class="text-xl font-bold tracking-wide">Techsure</div>
    <div class="relative">
      <button (click)="toggleDropdown($event)" class="text-white hover:text-gray-200 transition-colors focus:outline-none p-1">
        <!-- Kebab Menu Icon -->
        <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="5" r="2"></circle>
          <circle cx="12" cy="12" r="2"></circle>
          <circle cx="12" cy="19" r="2"></circle>
        </svg>
      </button>
      
      <!-- Dropdown -->
      <div *ngIf="isDropdownOpen" class="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-50 overflow-hidden">
        <button (click)="logout()" class="block w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors font-medium">
          Logout
        </button>
      </div>
    </div>
  </header>

  <!-- Gray padded background area -->
  <div class="flex-grow w-full px-4 sm:px-8 lg:px-12 py-6 flex flex-col">
    
    <!-- White Card Container -->
    <div class="bg-white shadow-sm border border-gray-200 rounded-lg flex-grow flex flex-col w-full overflow-hidden">
      
      <!-- Title Section & Navigation (Conditionally Displayed) -->
      <div *ngIf="showTitleSection" class="w-full px-8 py-6 flex items-center border-b border-gray-200 relative pb-10">
        <img src="../../../assets/icons/copilot-bot.png" class="w-14 h-14 mr-4" alt="Induction Bot" />
        <div>
          <h1 class="text-2xl font-bold text-[#1D4586]">Induction Training</h1>
          <p class="text-gray-500 text-sm mt-1">
            Work through your assessments, or ask Co-Pilot anything about the training.
          </p>
        </div>

        <div class="absolute -bottom-6 left-1/2 transform -translate-x-1/2 flex bg-white rounded-full shadow-md border border-gray-200 p-1.5 z-10">
          <a routerLink="/techsure/assessments" 
             routerLinkActive="bg-[#1D4586] text-white shadow-sm" 
             [routerLinkActiveOptions]="{exact: true}"
             class="px-6 py-2 rounded-full font-semibold text-sm transition-all text-gray-700 hover:bg-gray-100 mr-1">
            My Assessments
          </a>
          <a routerLink="/techsure/queries" 
             routerLinkActive="bg-[#1D4586] text-white shadow-sm"
             class="px-6 py-2 rounded-full font-semibold text-sm transition-all text-[#1D4586] hover:bg-gray-100 flex items-center">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
            </svg>
            Ask a Question
          </a>
        </div>
      </div>

      <!-- Child Component Content Area -->
      <div class="w-full flex-grow bg-[#F8F9FA]" [ngClass]="showTitleSection ? 'p-8 pt-12' : ''">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>

  <footer class="bg-[#E9F0E6] py-3 px-6 flex items-center text-xs text-gray-800 font-medium shrink-0">
    <div class="flex items-center">
        <span class="border-r border-gray-400 pr-2 mr-2">Powered by VIGI</span>
        <span>© {{ currentYear }} CleverNav</span>
    </div>
  </footer>

</div>